import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  
  {
    path: '',
    redirectTo: 'prod/auth/landing',
    pathMatch: 'full'
  },
  {
    path:'prod',
    children:[
      {
        path: 'auth',
        children: [
          {
            path: 'landing',
            loadChildren: () => import('./pages/prod/auth/landing/landing.module').then(m => m.LandingPageModule)
          },
          {
            path: 'login',
            loadChildren: () => import('./pages/prod/auth/login/login.module').then(m => m.LoginPageModule)
          },
        ]
      },
      {
        path: 'dashboard',
        children: [
          {
            path:'',
            loadChildren: () => import('./pages/prod/dashboard/dashboard.module').then(m => m.DashboardPageModule)
          },
          {
            path: 'routine',
            loadChildren: () => import('./pages/prod/routine/routine.module').then( m => m.RoutinePageModule)
          },
          {
            path: 'contact',
            loadChildren: () => import('./pages/prod/contact/contact.module').then( m => m.ContactPageModule)
          },
          {
            path: 'payment-history',
            loadChildren: () => import('./pages/prod/payment-history/payment-history.module').then( m => m.PaymentHistoryPageModule)
          },   
          {
            path: 'fees-payment',
            loadChildren: () => import('./pages/prod/fees-payment/fees-payment.module').then( m => m.FeesPaymentPageModule)
          },
          {
            path: 'chat',
            loadChildren: () => import('./pages/prod/chat/chat.module').then( m => m.ChatPageModule)
          },     
          {
            path: 'library',
            children: [
              {
                path: '',
                loadChildren: () => import('./pages/prod/library/library.module').then( m => m.LibraryPageModule)
              },
              {
                path: 'library-view',
                loadChildren: () => import('./pages/prod/pdf/library-view/library-view.module').then( m => m.LibraryViewPageModule)
              },
            ]
          },
          {
            path: 'assignment-download',
            loadChildren: () => import('./pages/prod/assignment-download/assignment-download.module').then( m => m.AssignmentDownloadPageModule)
          },
          {
            path: 'project-download',
            loadChildren: () => import('./pages/prod/project-download/project-download.module').then( m => m.ProjectDownloadPageModule)
          },
          {
            path: 'profile',
            loadChildren: () => import('./pages/prod/profile/profile.module').then( m => m.ProfilePageModule)
          },
          {
            path: 'sessionplan',
            children:[
              {
                path:'',
                loadChildren: () => import('./pages/prod/sessionplan/sessionplan.module').then( m => m.SessionplanPageModule)
              },
              {
                path: 'exam',
                children:[
                  {
                    path:'',
                    loadChildren: () => import('./pages/prod/session-plan/exam/exam.module').then( m => m.ExamPageModule)
                  },
                  {
                    path: 'plans',
                    loadChildren: () => import('./pages/prod/session-plan/plans/plans.module').then( m => m.PlansPageModule)
                  },
                
                ]
              },
            ]
          },
          {
            path: 'lessionplan',
            loadChildren: () => import('./pages/prod/lessionplan/lessionplan.module').then( m => m.LessionplanPageModule)
          },
          {
            path: 'projects',
            loadChildren: () => import('./pages/prod/projects/projects.module').then( m => m.ProjectsPageModule)
          },
          {
            path: 'assignment',
            loadChildren: () => import('./pages/prod/assignment/assignment.module').then( m => m.AssignmentPageModule)
          },
          {
            path: 'onlineexam',
            loadChildren: () => import('./pages/prod/onlineexam/onlineexam.module').then( m => m.OnlineexamPageModule)
          },
          {
            path: 'live-exam',
            loadChildren: () => import('./pages/prod/live-exam/live-exam.module').then( m => m.LiveExamPageModule)
          },       
          {
            path: 'notice',
            loadChildren: () => import('./pages/prod/notice/notice.module').then( m => m.NoticePageModule)
          },
          {
            path: 'school-bus',
            loadChildren: () => import('./pages/prod/school-bus/school-bus.module').then( m => m.SchoolBusPageModule)
          },
          {
            path: 'result',
            loadChildren: () => import('./pages/prod/result/result.module').then( m => m.ResultPageModule)
          },
          {
            path: 'complaints',
            children: [
              {
                path: '',
                loadChildren: () => import('./pages/prod/complaints/complaints.module').then( m => m.ComplaintsPageModule)
              },
              {
                path: 'complaints-add',
                loadChildren: () => import('./pages/prod/complaints-add/complaints-add.module').then( m => m.ComplaintsAddPageModule)
              },
            ]
          },
        ]
      }
    ]
  },
  
  {
    path: 'lession-view',
    loadChildren: () => import('./pages/modals/lession-view/lession-view.module').then( m => m.LessionViewPageModule)
  },
     
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
